import { render, staticRenderFns } from "./Transport.vue?vue&type=template&id=65e6c91e"
import script from "./Transport.vue?vue&type=script&lang=js"
export * from "./Transport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports